import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function OpuGradingTable() {
  const borderRight = { borderRight: '1px solid rgba(224, 224, 224, 1)' };
  const { data } = useSelector((state) => state.dataAnalyticsReducer);

  const getCellData = (key, index) => {
    if (!data || !data[index] || !data[index].oocyteEmbryo) {
      return 'N/A';
    }
    const oocyteEmbryo = data[index].oocyteEmbryo;
    if (key === 'day3Grade') {
      let gradeA = 0;
      let gradeB = 0;
      let gradeC = 0;

      for (let i = 0; i < oocyteEmbryo.day3.data.length; i++) {
        if (oocyteEmbryo.day3.data[i].grade === 'A') {
          gradeA++;
        }
        if (oocyteEmbryo.day3.data[i].grade === 'B') {
          gradeB++;
        }
        if (oocyteEmbryo.day3.data[i].grade === 'C') {
          gradeC++;
        }
      }
      return {
        gradeA,
        gradeB,
        gradeC,
      };
    }

    if (key === 'day5Grade') {
      let gradeA = 0;
      let gradeB = 0;
      let gradeC = 0;

      for (let i = 0; i < oocyteEmbryo.day5.data.length; i++) {
        if (oocyteEmbryo.day5.data[i].overallGrade === 'A') {
          gradeA++;
        }
        if (oocyteEmbryo.day5.data[i].overallGrade === 'B') {
          gradeB++;
        }
        if (oocyteEmbryo.day5.data[i].overallGrade === 'C') {
          gradeC++;
        }
      }
      return {
        gradeA,
        gradeB,
        gradeC,
      };
    }

    if (key === 'noOfEmbExtendedToDay5') {
      let count = 0;
      for (let i = 0; i < oocyteEmbryo.day4.data.length; i++) {
        if (oocyteEmbryo.day4.data[i].blastocystCulture === 'Yes') {
          count++;
        }
      }
      return count;
    }

    if (key === 'totalNoOfBlastocysts') {
      let count = 0;
      for (let i = 0; i < oocyteEmbryo.day5.data.length; i++) {
        if (oocyteEmbryo.day5.data[i].stage === 'Blastocyst') {
          count++;
        }
      }
      return count;
    }

    if (key === 'totalDiscardedEmbryos') {
      let count = 0;
      for (let i = 0; i < oocyteEmbryo.day6.data.length; i++) {
        if (oocyteEmbryo.day6.data[i].fate === 'Discard') {
          count++;
        }
      }
      return count;
    }
    return data[index][key] ?? 'N/A';
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={9}
            style={{
              fontWeight: 700,
              textAlign: 'center',
              ...borderRight,
            }}
          >
            EMBRYO GRADING AND DEVLOPMENT
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell
            colSpan={3}
            style={{ fontWeight: 700, textAlign: 'center' }}
          >
            <div style={{ width: '220px' }}>Day-3 Embryo Grading</div>
          </TableCell>
          <TableCell style={{ fontWeight: 700, textAlign: 'center' }}>
            <div style={{ width: '80px' }}>No of Emb. Extended To Day-5</div>
          </TableCell>
          <TableCell
            colSpan={3}
            style={{ fontWeight: 700, textAlign: 'center' }}
          >
            <div style={{ width: '220px' }}>Day-5 Embryo Grading</div>
          </TableCell>
          <TableCell style={{ fontWeight: 700, textAlign: 'center' }}>
            <div style={{ width: '120px' }}>
              Total No. of Blastocysts devloped on Day-5
            </div>
          </TableCell>
          <TableCell
            style={{ fontWeight: 700, textAlign: 'center', ...borderRight }}
          >
            Total Discarded Embryos
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ fontWeight: 700 }}>Grade-A</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Grade-B</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Grade-C</TableCell>
          <TableCell style={{ fontWeight: 700 }}></TableCell>
          <TableCell style={{ fontWeight: 700 }}>Grade-A</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Grade-B</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Grade-C</TableCell>
          <TableCell colSpan={2}></TableCell>
        </TableRow>

        {data.map((_, index) => (
          <TableRow key={index}>
            <TableCell style={{ textAlign: 'center' }}>
              <div
                style={{
                  height: '60px',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                }}
              >
                {getCellData('day3Grade', index).gradeA}
              </div>
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <div
                style={{
                  height: '60px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {getCellData('day3Grade', index).gradeB}
              </div>
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <div
                style={{
                  height: '60px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {getCellData('day3Grade', index).gradeC}
              </div>
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <div
                style={{
                  height: '60px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {getCellData('noOfEmbExtendedToDay5', index)}
              </div>
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <div
                style={{
                  height: '60px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {getCellData('day5Grade', index).gradeA}
              </div>
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <div
                style={{
                  height: '60px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {getCellData('day5Grade', index).gradeB}
              </div>
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <div
                style={{
                  height: '60px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {getCellData('day5Grade', index).gradeC}
              </div>
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <div
                style={{
                  height: '60px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {getCellData('totalNoOfBlastocysts', index)}
              </div>
            </TableCell>
            <TableCell style={{ ...borderRight, textAlign: 'center' }}>
              <div
                style={{
                  height: '60px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {getCellData('totalDiscardedEmbryos', index)}
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default OpuGradingTable;
